import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import { isAuthorityAdmin, isSuperuser } from 'Services/common/Features/User/userSlice'
import { PartialTariffProductForm } from 'Services/ProductManagement/Features/Product/Components/PartialTariffProductForm'
import { ProductForm } from 'Services/ProductManagement/Features/Product/Components/ProductForm'
import { SELECTED_PRODUCT_PARAMETER_KEY } from 'Services/ProductManagement/Features/Product/Hooks/useProductsWithParams'
import { useGetSingleProductQuery } from 'Services/ProductManagement/Features/Product/productApi'
import { useSelectedTariff } from 'Services/ProductManagement/Features/Tariff/Hooks'
import { useGetSingleVatDefinitionQuery } from 'Services/ProductManagement/Features/VATDefinition/vatDefinitionApi'
import { useTypedSelector } from 'Store'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { IS_HSL_SERVICE_ENVIRONMENT, PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import getTranslation from 'Util/getTranslation'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function TariffProductEditPage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs`
  const { id: tariffId, productId } = useParams()
  const previousLocation = usePreviousLocation(
    `${baseUrl}/${tariffId}/products?${SELECTED_PRODUCT_PARAMETER_KEY}=${productId}`
  )
  const { singleTariff } = useSelectedTariff(tariffId)
  const { user } = useTypedSelector(state => state.user)

  const { data: singleProduct, isLoading: isSingleProductLoading } = useGetSingleProductQuery(
    productId ?? '',
    {
      skip: !productId
    }
  )

  const { data: singleVatDefinition = null, isFetching: isSingleVatDefinitionFetching } =
    useGetSingleVatDefinitionQuery(singleTariff?.vat_definition_id ?? '', {
      refetchOnMountOrArgChange: true,
      skip: !singleTariff?.vat_definition_id || isAuthorityAdmin(user)
    })

  const breadcrumbs = [
    {
      title: t`Home`,
      link: PRODUCT_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Tariffs`,
      link: baseUrl
    },
    {
      title: singleTariff ? singleTariff.description : '',
      link: `${baseUrl}/${tariffId}/products`
    },
    {
      title: singleProduct ? getTranslation(singleProduct.translations, 'fi').name : ''
    }
  ]

  const isLoading = isSingleProductLoading || isSingleVatDefinitionFetching

  const getProductForm = () => {
    if (!singleProduct) return

    if (IS_HSL_SERVICE_ENVIRONMENT || isSuperuser(user)) {
      return (
        <ProductForm
          product={singleProduct}
          successBaseUrl={previousLocation}
          vatDefinition={singleVatDefinition}
        />
      )
    } else {
      return <PartialTariffProductForm product={singleProduct} successBaseUrl={previousLocation} />
    }
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit product`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>{getProductForm()}</WithLoader>
    </Box>
  )
}
